import {
  Box,
  DisplayPosition,
  Image,
  ResponsiveValue,
  Visible,
} from '@gousto-internal/citrus-react'
import React from 'react'

export const ChickPeasPattern = ({
  chickPeasImage,
  topSpace,
}: {
  chickPeasImage: string
  topSpace: string
}) => (
  <Visible display={['block', 'block', 'none']}>
    <Box position={DisplayPosition.Absolute} top={topSpace} right="0">
      <Image fit="cover" alt="" src={chickPeasImage} />
    </Box>
  </Visible>
)

export const ChickPeasPatternWide = ({
  display,
  src,
}: {
  display: ResponsiveValue<'block' | 'none'>
  src: string
}) => (
  <Visible display={display}>
    <Box left="-400px" position={DisplayPosition.Absolute}>
      <Image fit="cover" alt="" src={src} />
    </Box>
  </Visible>
)
